export function getSign(value: number): number {
  return value && value / Math.abs(value);
}

export function getRandomFromInterval(min: number, max: number): number {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function degToRad(degrees: number): number {
  const pi: number = Math.PI;
  return degrees * (pi / 180);
}

export function getRandomID(): number {
  return 100000 + Math.floor(Math.random() * 900000);
}